const faqs = [
  {
    question: '91网页浏览器是免费的吗？',
    answer: '是的，91网页浏览器完全免费使用。我们承诺不会向用户收取任何费用，所有核心功能——包括极速浏览、广告拦截、隐私保护、跨设备同步——均可免费使用。',
  },
  {
    question: '91浏览器支持哪些操作系统？',
    answer: '91网页浏览器目前支持Windows 10/11、macOS 11+以及主流Linux发行版（Ubuntu、Fedora、Debian等）。同时提供iOS和Android移动端版本，支持跨平台数据同步。',
  },
  {
    question: '我的浏览数据安全吗？如何保障隐私？',
    answer: '我们采用端到端加密技术保护您的同步数据，使用零知识架构确保即使是91浏览器团队也无法访问您的加密数据。本地浏览数据完全由您掌控，可以随时清除。',
  },
  {
    question: '91浏览器的广告拦截会影响正常网站访问吗？',
    answer: '我们的智能广告拦截引擎能精准区分恶意广告和正常内容。对于需要依赖广告收入的优质网站，您可以将它们加入白名单，允许展示合规广告，同时保持对其他网站的保护。',
  },
  {
    question: '如何将其他浏览器的数据迁移到91浏览器？',
    answer: '首次启动时，91浏览器会自动检测您电脑上已安装的其他浏览器，并提供一键导入选项。支持导入书签、密码、历史记录和Cookie，整个过程只需几分钟即可完成。',
  },
  {
    question: '91浏览器的系统资源占用情况如何？',
    answer: '91浏览器经过深度优化，在相同使用场景下，内存占用比主流浏览器低约20%-30%。标签休眠功能可进一步降低空闲标签页的资源消耗，即使配置较低的电脑也能流畅运行。',
  },
];

export default function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-3.5 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold font-label mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            您可能想了解
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <details
              key={index}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-6 py-5 font-medium text-foreground-900 text-base list-none">
                {faq.question}
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform w-5 h-5 flex items-center justify-center ml-4 flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-5 text-foreground-600 text-sm leading-relaxed">
                {faq.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}